// extracted by css-extract-rspack-plugin
export default {"tableHead":"tableHead-JkYli_","quantityTableHeader":"quantityTableHeader-nRtYOf","editButton":"editButton-vgkXTv","headerContainer":"headerContainer-EK71wu"};